import React from 'react';

import { Button, Skeleton, Typography, ButtonProps } from '@mui/material';
import Link from '../../../../../theme/components/Link';
import { Base64 } from '../../../../../util/Base64';
import { useControlUnitById } from '../../../../../redux/controlUnit/hooks/useControlUnitById';
import useShowErrorMessage from '../../../../../handlingErrors/useShowErrorMessage';

import { useAppSelector } from '../../../../../redux/store.model';
import { getFeatureToggle } from '../../../../../featureToggle';
import { UserInterfaceIcon } from '../../../../../theme/icons';
import useWatchError from '../../../../../handlingErrors/useWatchError';
import ControlUnitText from '../ControlUnitText/ControlUnitText';

interface ControlUnitButtonProps extends ButtonProps {
  controlUnitId?: number;
  deviceId?: string;
  commanderName?: string;
}
function ControlUnitButton(props: ControlUnitButtonProps) {
  const { controlUnitId, deviceId = '', commanderName, ...buttonProps } = props;
  const featureToggle = useAppSelector(getFeatureToggle);
  const { isLoading: isLoadingControlUnit, error: errorControlUnits } =
    useControlUnitById(deviceId, controlUnitId + '');
  useWatchError(errorControlUnits);
  return (
    <>
      {featureToggle?.controlUnitsDetailsView ? (
        <Link
          to={`/devicemanager/device/${deviceId}/device-detail/control-unit/${controlUnitId}`}
        >
          <Button
            variant="outlined"
            endIcon={<UserInterfaceIcon />}
            {...buttonProps}
          >
            {isLoadingControlUnit ? (
              <Skeleton variant="rectangular" height={'1em'} width={'4em'} />
            ) : (
              <Typography variant="h6" fontSize={'1rem'}>
                <ControlUnitText
                  controlUnitId={controlUnitId}
                  deviceId={deviceId}
                  commanderName={commanderName}
                />
              </Typography>
            )}
          </Button>
        </Link>
      ) : (
        <Typography variant="subtitle2" fontSize={'1rem'}>
          <ControlUnitText
            controlUnitId={controlUnitId}
            deviceId={deviceId}
            commanderName={commanderName}
          />
        </Typography>
      )}
    </>
  );
}

export default ControlUnitButton;
